





















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import StatusPanel from '@/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import BaseInfoPanelWithBadge from '@/components/BaseInfoPanelWithBadge.vue';
import { Inquiry, WayBill } from '@/http';
import ButtonPanel from '@/components/ButtonPanel.vue';
import CspDialog from '@/components/CspDialog.vue';
import { formRules } from '@/common/util/validator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import publicFunc from '../../../common/util/publicFunc';
import ScrollImage from './components/ScrollImage.vue';
import ImageSwiper from './components/ImageSwiper.vue';
//import DivSwiper from './components/divSwiper.vue'
import OrderInfo from './components/OrderInfo.vue';
import Evalute from './components/Evalute.vue';
import WayBillInfo from './components/WayBillInfo.vue';
import CommonPanel from '@/components/CommonPanel.vue';
import Location from './components/LocationTab.vue';

@Component({
    components: {
        BaseContainer,
        StatusPanel,
        BaseInfoPanel,
        ButtonPanel,
        CspDialog,
        DataPanel,
        ScrollImage,
        BaseInfoPanelWithBadge,
        CommonPanel,
        ImageSwiper,
        OrderInfo,
        Evalute,
        WayBillInfo,
        Location        
    },
})
export default class WayBillDetail extends Vue {
    public winVisible = false;
    public formDataWin: any = {};
    public loading: boolean = false;
    public adjustCarrierVisible = false;
    public requoteVisible = false;
    public activeName: any = 'first';
    public title: string = '运单详情分为计划信息、运单信息、定位信息、评价信息，实现从派车、发货、在途跟踪、送达全流程跟踪';
    public cspdiaConfig: any = {
        cspDialogVisible: false,
        title: '询价单终结',
        content: '确认终结询价单？',
    };
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public id: any = '';
    public name: any = '';
    public orderCnt: any = 0;
    public detailData: any = {};
    public goodsList: any = [];
    public formDataRequote: any = {};
    public skipType: any = '';
    public fee: any = ''; //财务模块跳转字段
    public status:any = '';
    public yddw3:boolean = false;//运单定位
    public async created() {
        this.fee = this.$route.query.fee;
        this.id = this.$route.query.orderId;
        this.name = this.$route.query.name;
        this.orderCnt = this.$route.query.orderCnt;
        this.activeName = this.$route.query.tab ? this.$route.query.tab : 'first';
        this.skipType = this.$route.query.type;
        this.status = this.$route.query.status;
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.yddw3 = webMenus.includes('yddw3');
        if(this.status == 2 || this.status == 3){
            this.showLocation = true;
        }else{
            this.showLocation = false;
        }
        if ((this.skipType && this.skipType === 'fee') || (this.skipType && this.skipType==='error')) {
            this.showorder = false;
            this.showEvalute = false;
            this.showLocation = false;
            this.activeName = 'second';
        } else {
            this.showorder = true;
        }
        // let res = await Carrier.GetList({ count: -1 });
        // this.carrierList = res.data;
        await this.reload();
    }
    public allCarrierBtnList: any = [];
    public allCarrierBtnListId: any = [];
    public tableList: any = [];
    public inquiryCarrierList: any = [];
    public evalute: any = {
        hs: '',
        checkList: [],
        rate: '',
    };
    public activities = [
        {
            content: '支持使用图标',
            timestamp: '2018-04-12 20:46',
            size: 'large',
            type: 'primary',
            icon: 'el-icon-more',
        },
        {
            content: '支持自定义颜色',
            timestamp: '2018-04-03 20:46',
            color: '#0bbd87',
        },
        {
            content: '支持自定义尺寸',
            timestamp: '2018-04-03 20:46',
            size: 'large',
        },
        {
            content: '默认样式的节点',
            timestamp: '2018-04-03 20:46',
        },
    ];
    
    public showorder: boolean = false;
    public showwaybill: boolean = false;
    public showEvalute: boolean = false;
    public showLocation:boolean = false;
    public showLocationContent:boolean = false;
    evalutInfo: any = {};
    async reload() {
        WayBill.GetDetail(this.id)
            .then((res) => {
                this.detailData = res;
                this.showwaybill = true;
                console.log('enter-->', this.detailData);                
                //已送达获取评价信息
                // if (this.detailData.carrierOrderStatus === 3) {
                //     WayBill.getEvalute({ carrierOrderId: this.detailData.id })
                //         .then((res) => {
                //             this.evalutInfo = res;
                //             this.showEvalute = true;
                //         })
                //         .catch((err) => {
                //             this.showEvalute = true;
                //         });
                // } else {
                //     this.showEvalute = false;
                // }
            })
            .catch((err) => {
                this.showwaybill = true;
            });
        this.tableData = [];
        this.tableList = [];
        this.inquiryCarrierList = [];
        this.isChangeCarrier = false;
    }
    public async mounted() {
        //this.reload();
    }
    public spanArr = [];
    public pos = 0;
    getSpanArr(data) {
        this.spanArr = [];
        for (var i = 0; i < data.length; i++) {
            if (i === 0) {
                this.spanArr.push(1);
                this.pos = 0;
            } else {
                // 判断当前元素与上一个元素是否相同  inAccessCode（批次字段）
                if (data[i].carrierName === data[i - 1].carrierName) {
                    this.spanArr[this.pos] += 1;
                    this.spanArr.push(0);
                } else {
                    this.spanArr.push(1);
                    this.pos = i;
                }
            }
        }
    }

    public requoteClose() {
        this.requoteVisible = false;
    }

    public async saveRequote() {
        if (this.currentBtn.length == 0) {
            this.$message.warning('请选择承运商');
        } else {
            let carrierIds = [];
            this.currentBtn.forEach((i) => {
                let res = this.allCarrierBtnListId.filter((v) => v.name == i)[0];
                carrierIds.push(res.id);
            });
            // await Inquiry.BackQuote({
            //     inquiryId: this.id,
            //     carrierIds: carrierIds,
            // });
            this.$message.success('定向询价承运商调整成功！');
            this.$router.push('/SingleInquiry');
        }
    }
    public $refs: {
        formData: HTMLFormElement;
    };

    public saveAdjustCarrier() {
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                // await Inquiry.UpdateCarriers({
                //     inquiryId: this.id,
                //     carrierIds: this.formData.carrierIds,
                // });
                this.$message.success('定向询价承运商调整成功！');
                this.$router.push('/SingleInquiry');
            }
        });
    }

    public isChangeCarrier = false;
    public changeCarrier() {
        this.isChangeCarrier = true;
    }
    public formData: any = { carrierIds: [] };
    public dynamicTags = [];
    handleDelTag(tag) {
        let flag = true;
        try {
            this.detailData.inquiryQuotes.forEach((i) => {
                if (i.carrierName == tag.name) {
                    flag = false;
                    this.$message.warning('该承运商已报价，无法删除!');
                    throw Error();
                }
            });
        } catch (e) {}
        if (flag) {
            this.formData.carrierIds = [];
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            this.dynamicTags.forEach((item) => {
                this.formData.carrierIds.push(item.id);
            });
            this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        }
    }
    public carrierChange(data) {
        let flag = true;
        let arr1 = [];
        let arr2 = [];
        if (this.formData.carrierIds.length >= this.oldData) {
            arr1 = this.formData.carrierIds;
            arr2 = this.oldData;
        } else {
            arr1 = this.oldData;
            arr2 = this.formData.carrierIds;
        }
        let res = [];
        res.push(
            arr1.filter((item) => {
                return !arr2.includes(item);
            })
        );
        try {
            this.detailData.inquiryQuotes.forEach((i) => {
                if (i.carrierId == res[0]) {
                    flag = false;
                    this.$message.warning('该承运商已报价，无法删除!');
                    this.formData.carrierIds = JSON.parse(JSON.stringify(this.oldData));
                    throw Error();
                }
            });
        } catch (e) {}
        if (flag) {
            this.dynamicTags = [];
            this.formData.carrierIds.forEach((item) => {
                let res = this.carrierList.filter((v) => v.id == item)[0];
                this.dynamicTags.push({
                    name: res.name,
                    id: res.id,
                });
            });
            this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        }
    }
    public tableData: any = [];
    public colData: any = [];

    public adjustCarrierClose() {
        this.$refs.formData.resetFields();
        this.adjustCarrierVisible = false;
    }

    public oldData: any = [];
    //调整承运商
    adjustCarrier() {
        this.adjustCarrierVisible = true;
        this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        this.dynamicTags = [];

        this.formData.carrierIds.forEach((item) => {
            let res = this.carrierList.filter((v) => v.id == item)[0];
            this.dynamicTags.push({
                name: res.name,
                id: res.id,
            });
        });
    }
    //一键催报
    async reminder() {
        // await Inquiry.Urge(this.id);
        // this.$message.warning('单笔询价催报成功！');
    }
    //承运商重新报价
    requote() {
        this.requoteVisible = true;
        let currBtnName = [];
        this.inquiryCarrierList.forEach((item) => {
            currBtnName.push(item.carrierName);
        });
        this.currentBtn = currBtnName;

        console.log('this.allCarrierBtnList' + JSON.stringify(this.allCarrierBtnList));
        console.log('  this.currentBtn' + JSON.stringify(this.currentBtn));
    }
    //一键否决
    reject() {
        this.$confirm('承运商报价全部拒绝!', '一键否决', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                // Inquiry.RejectAllQuote(this.id).then(() => {
                //     this.$message.success('单笔询价招标失败！');
                //     this.$router.push('/SingleInquiry');
                // });
            })
            .catch(() => {});
    }
    loadingEffect = [];
    public winTip: any = '';
    public winRemark: any = '';

    public timesIndex: any = '';
    public tag = false;
    public carrierId: any = '';
    public bidding(row, tag) {
        this.tag = tag;
        this.timesIndex = row.timesIndex;
        this.carrierId = row.quotes[0].carrierId;
        console.log('row' + JSON.stringify(row));
        if (tag) {
            let str = '';
            row.quotes.forEach((item) => {
                str += '【' + item.carLength + '】中标价:' + '【' + item.price + '】,';
            });
            str = str.substring(0, str.lastIndexOf(','));
            this.winTip = str + '   确认 ' + row.carrierName + ' 中标?';
        } else {
            this.winTip = '确认取消' + row.carrierName + '中标?';
        }

        this.winRemark = '';
        this.winVisible = true;
    }
    public async saveWin() {
        if (this.tag) {
            // await Inquiry.Win({
            //     inquiryId: this.id,
            //     carrierId: this.carrierId,
            //     timesIndex: this.timesIndex,
            //     winRemark: this.winRemark,
            // });
            this.$message.success('询价单招标成功！');
        } else {
            // await Inquiry.CancelWin({
            //     inquiryId: this.id,
            //     carrierId: this.carrierId,
            //     timesIndex: this.timesIndex,
            //     cancelRemark: this.winRemark,
            // });
            this.$message.success('询价单取消成功!');
        }

        this.winVisible = false;
        this.$router.push('/SingleInquiry');
    }
    winClose() {
        this.winRemark = '';
        this.winTip = '';
        this.winVisible = false;
    }
    cellClass({ row, column, rowIndex, columnIndex }) {
        if (this.detailData.statusStr == '招标成功') {
            if (row.isWin && columnIndex != 0) {
                return 'background: #f0f9eb;';
            } else {
                return '';
            }
        }
    }

    /**新增询价单 */
    public async addInquiry() {
        this.dialogBtn = 'save';
        this.cspdiaConfig = {
            cspDialogVisible: true,
            title: '询价单发布',
            content: '确认发布询价单？',
        };
    }

    editInquiry() {
        this.$router.push({
            path: '/AddInquiry',
            query: {
                id: this.id,
                type: 'edit',
            },
        });
    }
    public dialogBtn: string = '';
    /**终结询价单 */
    endInquiry() {
        this.$confirm('确认终结该询价单?', '询价单终结', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                // Inquiry.EndInquiry(this.id).then(() => {
                //     this.$message.success('询价单终结成功');
                //     this.$router.push('/SingleInquiry');
                // });
            })
            .catch(() => {});
    }
    /**删除询价单 */
    deleteInquiry() {
        this.$confirm('确认删除该询价单?', '询价单删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                // Inquiry.DelInquiry(this.id).then(() => {
                //     this.$message.success('询价单删除成功');
                //     this.$router.push('/SingleInquiry');
                // });
            })
            .catch(() => {});
    }

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
            const _row = this.spanArr[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
                rowspan: _row,
                colspan: _col,
            };
        }
    }
    public currentBtn: any = [];

    public editForm: any = {};
    public fileList: any = [];
    public goodsForm: any = {};

    cspdiaClose() {}

    back() {
        if (this.fee) {
            switch (this.fee) {
                case '1':
                    this.$router.push('/CostAudit');
                    break;
                case '2':
                    this.$router.push('/CostDetail');
                    break;
                case '3':
                    // this.$router.go(-1);
                    this.$router.push({
                        path: '/statementDetails',
                        query: {
                            id: this.$route.query.feeId,
                        },
                    });
                    break;
                default:
                    break;
            }
        } else {
            this.$router.push('/WayBillManage');
        }
    }

    viewFile(item) {
        if (publicFunc.getExtension2(item.name)) {
            window.open(`https://view.officeapps.live.com/op/view.aspx?src=${item.path}`);
        } else {
            window.open(item.path);
        }
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    public processStatus: boolean = false;
    public processList = [];
    public takeTime = null;
    public firData = null;
    public SecData = null;
    public d: number = 0;
    public h: number = 0;
    public m: any = 0;
    public s: any = 0;
    public time: string = '';
    public timer: any = null;

    async getprocess(e) {
        e.stopPropagation();
        this.processStatus = !this.processStatus;
        if (this.processStatus) {
            this.processList = [];
            let res = await WayBill.getTrackList({ carrierOrderId: this.id });
            this.processList = res.data;
            this.takeTime = this.processList[this.processList.length - 1].creationTime;
            this.firData = this.processList[0].creationTime;
            this.SecData = this.processList[this.processList.length - 1].creationTime;
            this.countTime();
            console.log('this.processList' + JSON.stringify(this.processList));
        }
    }

    countTime() {
        if (this.detailData.carrierOrderStatus != 3 && this.detailData.carrierOrderStatus != 4) {
            //获取当前时间
            let date = new Date();
            let now = date.getTime();
            //设置截止时间
            let xtime = this.takeTime.replace(/-/g, '/')
            var endDate = new Date(Date.parse(xtime));
            // let endDate = new Date(Date.parse(this.takeTime));
            let end = endDate.getTime();
            //时间差
            let leftTime = now - end;
            //定义变量 d,h,m,s保存倒计时的时间

            this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
            this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
            this.m = Math.floor((leftTime / 1000 / 60) % 60);
            this.s = Math.floor((leftTime / 1000) % 60);
            this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
            this.timer = setTimeout(this.countTime, 1000);
        } else {
            let date = new Date(Date.parse(this.firData.replace(/-/g, '/')));
            let now = date.getTime();
            //设置截止时间
            let endDate = new Date(Date.parse(this.SecData.replace(/-/g, '/')));
            let end = endDate.getTime();
            //时间差
            let leftTime = now - end;
            //定义变量 d,h,m,s保存倒计时的时间

            this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
            this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
            this.m = Math.floor((leftTime / 1000 / 60) % 60);
            this.s = Math.floor((leftTime / 1000) % 60);
            this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
        }
    }

    countTime2() {
        var nowData = new Date(Date.parse(this.firData.replace(/-/g, '/')));
        var now = nowData.getTime();
        var endDate = new Date(Date.parse(this.SecData.replace(/-/g, '/')));
        var end = endDate.getTime();
        var leftTime = now - end;
        //定义变量 d,h,m,s保存倒计时的时间
        console.log('leftTime' + leftTime);

        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
        this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
    }
    @Watch('processStatus')
    processStatusChange() {
        if (this.processStatus == false) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }
    }

    public carrierList = [];
    getCarrierList() {
        // CspInquiry.getLoadType({ typeName: '装车要求' }).then((res) => {
        //     this.carrierList = res.map((v) => {
        //         return v.stringData;
        //     });
        // });
    }
    updateBtn(item, index) {
        console.log('item' + JSON.stringify(item));
        if (this.currentBtn.includes(item)) {
            this.currentBtn.splice(this.currentBtn.indexOf(item), 1);
        } else {
            this.currentBtn.push(item);
        }
        console.log('this.currentBtn' + JSON.stringify(this.currentBtn));
    }

    downLoad(path) {
        window.open(path);
    }
    handleClick(val){
        console.log('tabs-->',val.name);
        if(val.name == 'forth'){
            this.showLocationContent = true;
        }else{
            this.showLocationContent = false;
        }
    }
}
